(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3932],{

/***/ 15746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21584);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 42561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ input; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js
var context = __webpack_require__(53124);
// EXTERNAL MODULE: ./node_modules/antd/es/form/context.js
var form_context = __webpack_require__(65223);
// EXTERNAL MODULE: ./node_modules/antd/es/input/style/index.js
var style = __webpack_require__(47673);
;// CONCATENATED MODULE: ./node_modules/antd/es/input/Group.js






const Group = props => {
  const {
    getPrefixCls,
    direction
  } = (0,react.useContext)(context/* ConfigContext */.E_);
  const {
    prefixCls: customizePrefixCls,
    className = ''
  } = props;
  const prefixCls = getPrefixCls('input-group', customizePrefixCls);
  const inputPrefixCls = getPrefixCls('input');
  const [wrapSSR, hashId] = (0,style/* default */.ZP)(inputPrefixCls);
  const cls = classnames_default()(prefixCls, {
    [`${prefixCls}-lg`]: props.size === 'large',
    [`${prefixCls}-sm`]: props.size === 'small',
    [`${prefixCls}-compact`]: props.compact,
    [`${prefixCls}-rtl`]: direction === 'rtl'
  }, hashId, className);
  const formItemContext = (0,react.useContext)(form_context/* FormItemInputContext */.aM);
  const groupFormItemContext = (0,react.useMemo)(() => Object.assign(Object.assign({}, formItemContext), {
    isFormItemInput: false
  }), [formItemContext]);
  return wrapSSR( /*#__PURE__*/react.createElement("span", {
    className: cls,
    style: props.style,
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    onFocus: props.onFocus,
    onBlur: props.onBlur
  }, /*#__PURE__*/react.createElement(form_context/* FormItemInputContext.Provider */.aM.Provider, {
    value: groupFormItemContext
  }, props.children)));
};
/* harmony default export */ var input_Group = (Group);
// EXTERNAL MODULE: ./node_modules/antd/es/input/Input.js + 1 modules
var Input = __webpack_require__(82586);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeInvisibleOutlined.js
// This icon file is generated automatically.
var EyeInvisibleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
/* harmony default export */ var asn_EyeInvisibleOutlined = (EyeInvisibleOutlined);

// EXTERNAL MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(93771);
;// CONCATENATED MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var EyeInvisibleOutlined_EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeInvisibleOutlined
  }));
};
EyeInvisibleOutlined_EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
/* harmony default export */ var icons_EyeInvisibleOutlined = (/*#__PURE__*/react.forwardRef(EyeInvisibleOutlined_EyeInvisibleOutlined));
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeOutlined.js
// This icon file is generated automatically.
var EyeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
/* harmony default export */ var asn_EyeOutlined = (EyeOutlined);

;// CONCATENATED MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/icons/EyeOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var EyeOutlined_EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeOutlined
  }));
};
EyeOutlined_EyeOutlined.displayName = 'EyeOutlined';
/* harmony default export */ var icons_EyeOutlined = (/*#__PURE__*/react.forwardRef(EyeOutlined_EyeOutlined));
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(98423);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
// EXTERNAL MODULE: ./node_modules/antd/es/input/hooks/useRemovePasswordTimeout.js
var useRemovePasswordTimeout = __webpack_require__(72922);
;// CONCATENATED MODULE: ./node_modules/antd/es/input/Password.js
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const defaultIconRender = visible => visible ? /*#__PURE__*/react.createElement(icons_EyeOutlined, null) : /*#__PURE__*/react.createElement(icons_EyeInvisibleOutlined, null);
const ActionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};
const Password = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    visibilityToggle = true
  } = props;
  const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
  const [visible, setVisible] = (0,react.useState)(() => visibilityControlled ? visibilityToggle.visible : false);
  const inputRef = (0,react.useRef)(null);
  react.useEffect(() => {
    if (visibilityControlled) {
      setVisible(visibilityToggle.visible);
    }
  }, [visibilityControlled, visibilityToggle]);
  // Remove Password value
  const removePasswordTimeout = (0,useRemovePasswordTimeout/* default */.Z)(inputRef);
  const onVisibleChange = () => {
    const {
      disabled
    } = props;
    if (disabled) {
      return;
    }
    if (visible) {
      removePasswordTimeout();
    }
    setVisible(prevState => {
      var _a;
      const newState = !prevState;
      if (typeof visibilityToggle === 'object') {
        (_a = visibilityToggle.onVisibleChange) === null || _a === void 0 ? void 0 : _a.call(visibilityToggle, newState);
      }
      return newState;
    });
  };
  const getIcon = prefixCls => {
    const {
      action = 'click',
      iconRender = defaultIconRender
    } = props;
    const iconTrigger = ActionMap[action] || '';
    const icon = iconRender(visible);
    const iconProps = {
      [iconTrigger]: onVisibleChange,
      className: `${prefixCls}-icon`,
      key: 'passwordIcon',
      onMouseDown: e => {
        // Prevent focused state lost
        // https://github.com/ant-design/ant-design/issues/15173
        e.preventDefault();
      },
      onMouseUp: e => {
        // Prevent caret position change
        // https://github.com/ant-design/ant-design/issues/23524
        e.preventDefault();
      }
    };
    return /*#__PURE__*/react.cloneElement( /*#__PURE__*/react.isValidElement(icon) ? icon : /*#__PURE__*/react.createElement("span", null, icon), iconProps);
  };
  const {
      className,
      prefixCls: customizePrefixCls,
      inputPrefixCls: customizeInputPrefixCls,
      size
    } = props,
    restProps = __rest(props, ["className", "prefixCls", "inputPrefixCls", "size"]);
  const {
    getPrefixCls
  } = react.useContext(context/* ConfigContext */.E_);
  const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
  const prefixCls = getPrefixCls('input-password', customizePrefixCls);
  const suffixIcon = visibilityToggle && getIcon(prefixCls);
  const inputClassName = classnames_default()(prefixCls, className, {
    [`${prefixCls}-${size}`]: !!size
  });
  const omittedProps = Object.assign(Object.assign({}, (0,omit/* default */.Z)(restProps, ['suffix', 'iconRender', 'visibilityToggle'])), {
    type: visible ? 'text' : 'password',
    className: inputClassName,
    prefixCls: inputPrefixCls,
    suffix: suffixIcon
  });
  if (size) {
    omittedProps.size = size;
  }
  return /*#__PURE__*/react.createElement(Input/* default */.Z, Object.assign({
    ref: (0,es_ref/* composeRef */.sQ)(ref, inputRef)
  }, omittedProps));
});
if (false) {}
/* harmony default export */ var input_Password = (Password);
// EXTERNAL MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/icons/SearchOutlined.js + 1 modules
var SearchOutlined = __webpack_require__(13805);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/SizeContext.js
var SizeContext = __webpack_require__(97647);
// EXTERNAL MODULE: ./node_modules/antd/es/space/Compact.js
var Compact = __webpack_require__(4173);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(96159);
;// CONCATENATED MODULE: ./node_modules/antd/es/input/Search.js
var Search_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










const Search = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
      prefixCls: customizePrefixCls,
      inputPrefixCls: customizeInputPrefixCls,
      className,
      size: customizeSize,
      suffix,
      enterButton = false,
      addonAfter,
      loading,
      disabled,
      onSearch: customOnSearch,
      onChange: customOnChange,
      onCompositionStart,
      onCompositionEnd
    } = props,
    restProps = Search_rest(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange", "onCompositionStart", "onCompositionEnd"]);
  const {
    getPrefixCls,
    direction
  } = react.useContext(context/* ConfigContext */.E_);
  const contextSize = react.useContext(SizeContext/* default */.Z);
  const composedRef = react.useRef(false);
  const prefixCls = getPrefixCls('input-search', customizePrefixCls);
  const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
  const {
    compactSize
  } = (0,Compact/* useCompactItemContext */.ri)(prefixCls, direction);
  const size = compactSize || customizeSize || contextSize;
  const inputRef = react.useRef(null);
  const onChange = e => {
    if (e && e.target && e.type === 'click' && customOnSearch) {
      customOnSearch(e.target.value, e);
    }
    if (customOnChange) {
      customOnChange(e);
    }
  };
  const onMouseDown = e => {
    var _a;
    if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) {
      e.preventDefault();
    }
  };
  const onSearch = e => {
    var _a, _b;
    if (customOnSearch) {
      customOnSearch((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.value, e);
    }
  };
  const onPressEnter = e => {
    if (composedRef.current || loading) {
      return;
    }
    onSearch(e);
  };
  const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/react.createElement(SearchOutlined/* default */.Z, null) : null;
  const btnClassName = `${prefixCls}-button`;
  let button;
  const enterButtonAsElement = enterButton || {};
  const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
  if (isAntdButton || enterButtonAsElement.type === 'button') {
    button = (0,reactNode/* cloneElement */.Tm)(enterButtonAsElement, Object.assign({
      onMouseDown,
      onClick: e => {
        var _a, _b;
        (_b = (_a = enterButtonAsElement === null || enterButtonAsElement === void 0 ? void 0 : enterButtonAsElement.props) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
        onSearch(e);
      },
      key: 'enterButton'
    }, isAntdButton ? {
      className: btnClassName,
      size
    } : {}));
  } else {
    button = /*#__PURE__*/react.createElement(es_button/* default */.ZP, {
      className: btnClassName,
      type: enterButton ? 'primary' : undefined,
      size: size,
      disabled: disabled,
      key: "enterButton",
      onMouseDown: onMouseDown,
      onClick: onSearch,
      loading: loading,
      icon: searchIcon
    }, enterButton);
  }
  if (addonAfter) {
    button = [button, (0,reactNode/* cloneElement */.Tm)(addonAfter, {
      key: 'addonAfter'
    })];
  }
  const cls = classnames_default()(prefixCls, {
    [`${prefixCls}-rtl`]: direction === 'rtl',
    [`${prefixCls}-${size}`]: !!size,
    [`${prefixCls}-with-button`]: !!enterButton
  }, className);
  const handleOnCompositionStart = e => {
    composedRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e);
  };
  const handleOnCompositionEnd = e => {
    composedRef.current = false;
    onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e);
  };
  return /*#__PURE__*/react.createElement(Input/* default */.Z, Object.assign({
    ref: (0,es_ref/* composeRef */.sQ)(inputRef, ref),
    onPressEnter: onPressEnter
  }, restProps, {
    size: size,
    onCompositionStart: handleOnCompositionStart,
    onCompositionEnd: handleOnCompositionEnd,
    prefixCls: inputPrefixCls,
    addonAfter: button,
    suffix: suffix,
    onChange: onChange,
    className: cls,
    disabled: disabled
  }));
});
if (false) {}
/* harmony default export */ var input_Search = (Search);
// EXTERNAL MODULE: ./node_modules/antd/es/input/TextArea.js + 4 modules
var TextArea = __webpack_require__(22913);
;// CONCATENATED MODULE: ./node_modules/antd/es/input/index.js





const input_Input = Input/* default */.Z;
if (false) {}
input_Input.Group = input_Group;
input_Input.Search = input_Search;
input_Input.TextArea = TextArea/* default */.Z;
input_Input.Password = input_Password;
/* harmony default export */ var input = (input_Input);

/***/ }),

/***/ 71230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92820);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 13805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_SearchOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/SearchOutlined.js
// This icon file is generated automatically.
var SearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
/* harmony default export */ var asn_SearchOutlined = (SearchOutlined);

// EXTERNAL MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/components/AntdIcon.js + 3 modules
var AntdIcon = __webpack_require__(93771);
;// CONCATENATED MODULE: ./node_modules/antd/node_modules/@ant-design/icons/es/icons/SearchOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var SearchOutlined_SearchOutlined = function SearchOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_SearchOutlined
  }));
};
SearchOutlined_SearchOutlined.displayName = 'SearchOutlined';
/* harmony default export */ var icons_SearchOutlined = (/*#__PURE__*/react.forwardRef(SearchOutlined_SearchOutlined));

/***/ }),

/***/ 61373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71577);
/* harmony import */ var shared_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77713);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["children"],
    _excluded2 = ["onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var WrappedButton = function WrappedButton(_ref) {
  var children = _ref.children,
      props = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var onClick = props.onClick,
      updatedProps = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded2);

  var onClickHandler = function onClickHandler(event) {
    if (props.source) {
      (0,shared_util__WEBPACK_IMPORTED_MODULE_2__/* .mixpanel_event */ .Zd)('button.click', {
        source: props.source
      });
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, _objectSpread(_objectSpread({
    onClick: onClickHandler
  }, updatedProps), {}, {
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (WrappedButton);

/***/ }),

/***/ 90544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CRWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 17 modules
var card = __webpack_require__(3679);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./layouts/widget.js




function WidgetLayout(props) {
  var children = props.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
      style: {
        textAlign: 'center',
        overflow: 'hidden',
        margin: 'auto'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
        size: "small" // title="Card Title" Title Here for Future Use
        ,
        style: {
          margin: 'auto',
          border: '1px solid #1890ff',
          padding: '0px',
          overflow: 'hidden'
        },
        bodyStyle: {
          padding: '0px'
        },
        children: [children, /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: ["Calculator by", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://fintrakk.com",
              target: "_parent",
              rel: "nofollow",
              children: " Fintrakk.com"
            })
          })]
        })]
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(42561);
// EXTERNAL MODULE: ./components/shared/button/index.tsx
var shared_button = __webpack_require__(61373);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/util.tsx + 6 modules
var util = __webpack_require__(77713);
;// CONCATENATED MODULE: ./components/calwidget/quick-ratio.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Title = typography/* default.Title */.Z.Title;
function QuickRatioComponent() {
  var router = (0,next_router.useRouter)();
  var _router$query$currenc = router.query.currency,
      currency = _router$query$currenc === void 0 ? 'dollar' : _router$query$currenc;

  var _useState = (0,react.useState)({
    assets: '',
    liabilities: '',
    inventory: '',
    result: ''
  }),
      values = _useState[0],
      setValues = _useState[1];

  var _useState2 = (0,react.useState)({
    assets: '#1890ff',
    liabilities: '#1890ff',
    inventory: '#1890ff'
  }),
      colors = _useState2[0],
      setColors = _useState2[1];

  var handleCalculation = function handleCalculation() {
    if ((0,util/* IswrongInput */.sg)(values.assets) || (0,util/* IswrongInput */.sg)(values.liabilities) || (0,util/* IswrongInput */.sg)(values.inventory)) {
      if ((0,util/* IswrongInput */.sg)(values.assets)) {
        setColors(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            assets: '#ff00008a'
          });
        });
      }

      if ((0,util/* IswrongInput */.sg)(values.liabilities)) {
        setColors(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            liabilities: '#ff00008a'
          });
        });
      }

      if ((0,util/* IswrongInput */.sg)(values.inventory)) {
        setColors(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            inventory: '#ff00008a'
          });
        });
      }
    } else {
      setValues(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          result: (0,util/* roundToTwo */.So)((values.assets - values.inventory) / values.liabilities)
        });
      });
    }
  };

  var handleChange = function handleChange(event) {
    var inputValue = event.target.value;
    var targetId = event.target.id;
    setValues(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, targetId, inputValue));
    });

    if ((0,util/* IswrongInput */.sg)(inputValue)) {
      setColors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, targetId, '#ff00008a'));
      });
    } else {
      setColors(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, (0,defineProperty/* default */.Z)({}, targetId, '#1890ff'));
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      level: 4,
      style: {
        height: '22px',
        fontWeight: '600',
        fontSize: '21px',
        lineHeight: '22px',
        alignItems: 'center',
        color: '#000000',
        margin: '16px 0px 16px 0px'
      },
      children: "Quick Ratio Calculator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "assets",
        placeholder: "Input Current Assets",
        onChange: handleChange,
        style: {
          width: '256px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, colors.assets)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "inventory",
        placeholder: "Input Current Inventory",
        onChange: handleChange,
        style: {
          width: '256px',
          marginTop: '8px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, colors.inventory)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "liabilities",
        placeholder: "Input Current Liabilities",
        onChange: handleChange,
        style: {
          width: '256px',
          marginTop: '8px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, colors.liabilities)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
        size: "large",
        type: "primary",
        style: {
          marginTop: '8px'
        },
        onClick: handleCalculation,
        children: "Calculate"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      level: 4,
      style: {
        fontSize: '14px',
        marginTop: '16px'
      },
      children: "Quick Ratio"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
      id: "liabilities",
      value: values.result,
      style: {
        width: '256px'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        style: {
          color: '#595959',
          fontSize: '13px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
          span: 24,
          style: {
            margin: '24px auto',
            width: '294px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            style: {
              width: '82px'
            },
            children: "Quick Ratio ="
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            style: {
              width: '212px'
            },
            children: "(Current Assets-Current Inventory)/ Current Liabilities"
          })]
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/calwidget/current-ratio.js







var current_ratio_Title = typography/* default.Title */.Z.Title;
function CurrentRatioComponent() {
  var router = (0,next_router.useRouter)();
  var _router$query$currenc = router.query.currency,
      currency = _router$query$currenc === void 0 ? 'dollar' : _router$query$currenc;

  var _useState = (0,react.useState)(''),
      assets = _useState[0],
      setassets = _useState[1];

  var _useState2 = (0,react.useState)(''),
      liabilities = _useState2[0],
      setliabilities = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      result = _useState3[0],
      setresult = _useState3[1];

  var _useState4 = (0,react.useState)('#1890ff'),
      assetsColor = _useState4[0],
      setassetsColor = _useState4[1];

  var _useState5 = (0,react.useState)('#1890ff'),
      liabilitiesColor = _useState5[0],
      setliabilitiesColor = _useState5[1];

  var handleCalculation = function handleCalculation() {
    if ((0,util/* IswrongInput */.sg)(assets) || (0,util/* IswrongInput */.sg)(liabilities)) {
      if ((0,util/* IswrongInput */.sg)(assets)) {
        setassetsColor('#ff00008a');
      }

      if ((0,util/* IswrongInput */.sg)(liabilities)) {
        setliabilitiesColor('#ff00008a');
      }
    } else {
      setresult((0,util/* roundToTwo */.So)(assets / liabilities));
    }
  };

  var handleChange = function handleChange(event) {
    var inputValue = event.target.value;

    if (event.target.id === 'assets') {
      setassets(inputValue);

      if ((0,util/* IswrongInput */.sg)(inputValue)) {
        setassetsColor('#ff00008a');
      } else {
        setassetsColor('#1890ff');
      }
    } else {
      setliabilities(inputValue);

      if ((0,util/* IswrongInput */.sg)(inputValue)) {
        setliabilitiesColor('#ff00008a');
      } else {
        setliabilitiesColor('#1890ff');
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      padding: '16px 8px 16px 8px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(current_ratio_Title, {
      level: 4,
      style: {
        height: '22px',
        fontWeight: '600',
        fontSize: '21px',
        lineHeight: '22px',
        alignItems: 'center',
        textAlign: 'center',
        color: '#000000'
      },
      children: "Current Ratio Calculator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "assets",
        placeholder: "Input Current Assets",
        onChange: handleChange,
        style: {
          width: '256px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, assetsColor)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "liabilities",
        placeholder: "Input Current Liabilities",
        onChange: handleChange,
        style: {
          width: '256px',
          marginTop: '16px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, liabilitiesColor)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
        size: "large",
        type: "primary",
        style: {
          margin: '8px auto auto auto'
        },
        onClick: handleCalculation,
        children: "Calculate"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(current_ratio_Title, {
      level: 4,
      style: {
        fontSize: '14px',
        marginTop: '16px',
        textAlign: 'center'
      },
      children: "Current Ratio"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
      id: "liabilities",
      value: result,
      style: {
        width: '256px'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        style: {
          color: '#595959',
          fontSize: '14px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
          span: 24,
          style: {
            margin: '24px auto'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: 9,
            style: {
              textAlign: 'center',
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center'
            },
            children: "Current Ratio"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: 2,
            style: {
              display: 'flex',
              alignItems: 'center'
            },
            children: "="
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
            span: 11,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                borderBottom: '1px solid',
                whiteSpace: 'nowrap'
              },
              children: "Current Assets"
            }), '\n', /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                whiteSpace: 'nowrap'
              },
              children: "Current Liabilities"
            })]
          })]
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/calwidget/pe-ratio.js







var pe_ratio_Title = typography/* default.Title */.Z.Title;
function PeRatioComponent() {
  var router = (0,next_router.useRouter)();
  var _router$query$currenc = router.query.currency,
      currency = _router$query$currenc === void 0 ? 'dollar' : _router$query$currenc;

  var _useState = (0,react.useState)(''),
      assets = _useState[0],
      setassets = _useState[1];

  var _useState2 = (0,react.useState)(''),
      liabilities = _useState2[0],
      setliabilities = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      result = _useState3[0],
      setresult = _useState3[1];

  var _useState4 = (0,react.useState)('#1890ff'),
      assetsColor = _useState4[0],
      setassetsColor = _useState4[1];

  var _useState5 = (0,react.useState)('#1890ff'),
      liabilitiesColor = _useState5[0],
      setliabilitiesColor = _useState5[1];

  var handleCalculation = function handleCalculation() {
    if ((0,util/* IswrongInput */.sg)(assets) || (0,util/* IswrongInput */.sg)(liabilities)) {
      if ((0,util/* IswrongInput */.sg)(assets)) {
        setassetsColor('#ff00008a');
      }

      if ((0,util/* IswrongInput */.sg)(liabilities)) {
        setliabilitiesColor('#ff00008a');
      }
    } else {
      setresult((0,util/* roundToTwo */.So)(assets / liabilities));
    }
  };

  var handleChange = function handleChange(event) {
    var inputValue = event.target.value;

    if (event.target.id === 'assets') {
      setassets(inputValue);

      if ((0,util/* IswrongInput */.sg)(inputValue)) {
        setassetsColor('#ff00008a');
      } else {
        setassetsColor('#1890ff');
      }
    } else {
      setliabilities(inputValue);

      if ((0,util/* IswrongInput */.sg)(inputValue)) {
        setliabilitiesColor('#ff00008a');
      } else {
        setliabilitiesColor('#1890ff');
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      padding: '16px 8px 16px 8px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(pe_ratio_Title, {
      level: 4,
      style: {
        height: '22px',
        fontWeight: '600',
        fontSize: '21px',
        lineHeight: '22px',
        alignItems: 'center',
        textAlign: 'center',
        color: '#000000'
      },
      children: "PE Ratio Calculator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "assets",
        placeholder: "Input Market Price per Share",
        onChange: handleChange,
        style: {
          width: '256px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, assetsColor)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "liabilities",
        placeholder: "Input Earnings Per Share",
        onChange: handleChange,
        style: {
          width: '256px',
          marginTop: '16px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, liabilitiesColor)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
        size: "large",
        type: "primary",
        style: {
          margin: '8px auto auto auto'
        },
        onClick: handleCalculation,
        children: "Calculate"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(pe_ratio_Title, {
      level: 4,
      style: {
        fontSize: '14px',
        marginTop: '16px',
        textAlign: 'center'
      },
      children: "PE Ratio"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
      id: "liabilities",
      value: result,
      style: {
        width: '256px'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        style: {
          color: '#595959',
          fontSize: '14px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
          span: 24,
          style: {
            margin: '24px auto'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: 9,
            style: {
              textAlign: 'center',
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center'
            },
            children: "PE Ratio"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: 2,
            style: {
              display: 'flex',
              alignItems: 'center'
            },
            children: "="
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
            span: 11,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                borderBottom: '1px solid',
                whiteSpace: 'nowrap'
              },
              children: "Market Price per Share"
            }), '\n', /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                whiteSpace: 'nowrap'
              },
              children: "Earnings Per Share"
            })]
          })]
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/calwidget/gross-profit-ratio.js







var gross_profit_ratio_Title = typography/* default.Title */.Z.Title;
function GrossProfitRatioComponent() {
  var router = (0,next_router.useRouter)();
  var _router$query$currenc = router.query.currency,
      currency = _router$query$currenc === void 0 ? 'dollar' : _router$query$currenc;

  var _useState = (0,react.useState)(''),
      assets = _useState[0],
      setassets = _useState[1];

  var _useState2 = (0,react.useState)(''),
      liabilities = _useState2[0],
      setliabilities = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      result = _useState3[0],
      setresult = _useState3[1];

  var _useState4 = (0,react.useState)('#1890ff'),
      assetsColor = _useState4[0],
      setassetsColor = _useState4[1];

  var _useState5 = (0,react.useState)('#1890ff'),
      liabilitiesColor = _useState5[0],
      setliabilitiesColor = _useState5[1];

  var handleCalculation = function handleCalculation() {
    if ((0,util/* IswrongInput */.sg)(assets) || (0,util/* IswrongInput */.sg)(liabilities)) {
      if ((0,util/* IswrongInput */.sg)(assets)) {
        setassetsColor('#ff00008a');
      }

      if ((0,util/* IswrongInput */.sg)(liabilities)) {
        setliabilitiesColor('#ff00008a');
      }
    } else {
      setresult((0,util/* roundToTwo */.So)(assets / liabilities * 100));
    }
  };

  var handleChange = function handleChange(event) {
    var inputValue = event.target.value;

    if (event.target.id === 'assets') {
      setassets(inputValue);

      if ((0,util/* IswrongInput */.sg)(inputValue)) {
        setassetsColor('#ff00008a');
      } else {
        setassetsColor('#1890ff');
      }
    } else {
      setliabilities(inputValue);

      if ((0,util/* IswrongInput */.sg)(inputValue)) {
        setliabilitiesColor('#ff00008a');
      } else {
        setliabilitiesColor('#1890ff');
      }
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: {
      padding: '16px 8px 16px 8px'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(gross_profit_ratio_Title, {
      level: 4,
      style: {
        height: '22px',
        fontWeight: '600',
        fontSize: '21px',
        lineHeight: '22px',
        alignItems: 'center',
        textAlign: 'center',
        color: '#000000',
        display: 'flex'
      },
      children: "Gross Profit Ratio Calculator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "assets",
        placeholder: "Input Gross Profit",
        onChange: handleChange,
        style: {
          width: '256px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, assetsColor)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
        id: "liabilities",
        placeholder: "Input Net sales",
        onChange: handleChange,
        style: {
          width: '256px',
          marginTop: '16px'
        },
        suffix: (0,util/* CurrencyIcon */.rm)(currency, liabilitiesColor)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
        size: "large",
        type: "primary",
        style: {
          margin: '8px auto auto auto'
        },
        onClick: handleCalculation,
        children: "Calculate"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(gross_profit_ratio_Title, {
      level: 4,
      style: {
        fontSize: '14px',
        marginTop: '16px',
        textAlign: 'center'
      },
      children: "Gross profit Ratio"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {
      id: "liabilities",
      value: result,
      style: {
        width: '256px'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        style: {
          color: '#595959',
          fontSize: '14px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
          span: 24,
          style: {
            margin: '24px auto'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: 9,
            style: {
              textAlign: 'center',
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center'
            },
            children: "Gross Profit Ratio"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: 2,
            style: {
              display: 'flex',
              alignItems: 'center'
            },
            children: "="
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
            span: 11,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                borderBottom: '1px solid',
                whiteSpace: 'nowrap'
              },
              children: "Gross Profit * 100"
            }), '\n', /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                whiteSpace: 'nowrap'
              },
              children: "Net Sales"
            })]
          })]
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/calwidget/index.js




/* harmony default export */ var calwidget = ({
  'current-ratio-formula': CurrentRatioComponent,
  'quick-ratio-formula': QuickRatioComponent,
  'pe-ratio-formula-price-to-earnings': PeRatioComponent,
  'gross-profit-ratio-meaning-formula-interpretation': GrossProfitRatioComponent
});
// EXTERNAL MODULE: ./shared/LoadingIndicator.js
var LoadingIndicator = __webpack_require__(23264);
;// CONCATENATED MODULE: ./components/calwidget/coming-soon.js






var coming_soon_Title = typography/* default.Title */.Z.Title;
function ComingSoon() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(coming_soon_Title, {
      level: 4,
      style: {
        height: '22px',
        fontWeight: '600',
        fontSize: '21px',
        lineHeight: '22px',
        alignItems: 'center',
        color: '#000000',
        margin: '32px 12px 16px 12px'
      },
      children: "Calculator Coming Soon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
      size: "large",
      type: "primary",
      style: {
        margin: '8px auto auto auto'
      },
      children: "Calculator"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        span: 24,
        style: {
          color: '#595959',
          fontSize: '14px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          span: 24,
          style: {
            margin: '48px auto'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
            span: 24,
            style: {
              textAlign: 'center',
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center'
            },
            children: "THIS CALCULATOR IS UNDER CONSTRUCTION!"
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(coming_soon_Title, {
      level: 4,
      style: {
        fontSize: '14px',
        marginTop: '16px'
      },
      children: "Financial Calculator"
    })]
  });
}
;// CONCATENATED MODULE: ./pages/widget/[slug].js







function CRWidget() {
  var router = (0,next_router.useRouter)();
  var slug = router.query.slug;
  var CalWidgetComponent = calwidget[slug];

  var _useState = (0,react.useState)(false),
      loaded = _useState[0],
      setloaded = _useState[1];

  (0,react.useEffect)(function () {
    setloaded(true);
  }, []);

  if (!loaded) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingIndicator/* default */.Z, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WidgetLayout, {
    children: CalWidgetComponent ? /*#__PURE__*/(0,jsx_runtime.jsx)(CalWidgetComponent, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(ComingSoon, {})
  });
}

/***/ }),

/***/ 35613:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/widget/[slug]",
      function () {
        return __webpack_require__(90544);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,7752,2913,1945,6873,3679,9774,2888,179], function() { return __webpack_exec__(35613); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);